import { render, staticRenderFns } from "./Prequiz.vue?vue&type=template&id=0aacdbec&scoped=true&"
import script from "./Prequiz.vue?vue&type=script&lang=js&"
export * from "./Prequiz.vue?vue&type=script&lang=js&"
import style0 from "./Prequiz.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Prequiz.vue?vue&type=style&index=1&id=0aacdbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aacdbec",
  null
  
)

export default component.exports